import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const FormTipIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.13235 1.94332C9.44191 1.94332 9.69292 1.69231 9.69292 1.38275V0.560574C9.69292 0.251012 9.44191 0 9.13235 0C8.82279 0 8.57178 0.251012 8.57178 0.560574V1.38275C8.57178 1.69231 8.82279 1.94332 9.13235 1.94332Z"
        fill="currentColor"
      />
      <path
        d="M1.38275 8.57227H0.560573C0.251012 8.57227 0 8.82328 0 9.13284C0 9.4424 0.251012 9.69341 0.560573 9.69341H1.38213C1.69169 9.69341 1.9427 9.4424 1.9427 9.13284C1.9427 8.82328 1.69231 8.57227 1.38275 8.57227Z"
        fill="currentColor"
      />
      <path
        d="M17.7044 8.57227H16.8828C16.5733 8.57227 16.3223 8.82328 16.3223 9.13284C16.3223 9.4424 16.5733 9.69341 16.8828 9.69341H17.7044C18.014 9.69341 18.265 9.4424 18.265 9.13284C18.265 8.82328 18.014 8.57227 17.7044 8.57227Z"
        fill="currentColor"
      />
      <path
        d="M14.7981 2.67463L14.2157 3.25576C13.9965 3.47501 13.9965 3.82941 14.2157 4.04866C14.3253 4.15828 14.4686 4.21309 14.6125 4.21309C14.7563 4.21309 14.8996 4.15828 15.0086 4.04928L15.591 3.46816C15.8102 3.24891 15.8102 2.8945 15.591 2.67526C15.3717 2.45601 15.0155 2.45601 14.7981 2.67463Z"
        fill="currentColor"
      />
      <path
        d="M4.04911 4.04874C4.26835 3.82949 4.26835 3.47508 4.04911 3.25584L3.46673 2.67471C3.24873 2.45609 2.89308 2.45609 2.67446 2.67471C2.45583 2.89333 2.45521 3.24836 2.67446 3.46761L3.25683 4.04874C3.36583 4.15774 3.50909 4.21255 3.65297 4.21255C3.79685 4.21255 3.93948 4.15836 4.04911 4.04874Z"
        fill="currentColor"
      />
      <path
        d="M8.50977 4.09343C6.26748 4.3569 4.41509 6.12333 4.06069 8.35379C3.73991 10.3731 4.59759 12.2155 6.05134 13.3061C6.45807 13.6113 6.71407 14.0704 6.72901 14.5762H11.5356C11.5487 14.0735 11.801 13.6145 12.2058 13.3124C13.4596 12.3756 14.2718 10.8814 14.2718 9.1959C14.2718 6.15198 11.6266 3.72657 8.50977 4.09343Z"
        fill="currentColor"
      />
      <path
        d="M6.73438 15.5107V15.6017C6.73438 16.2681 7.0022 16.8661 7.43821 17.2959C7.86798 17.7319 8.47215 17.9997 9.13238 17.9997C10.4591 17.9997 11.5304 16.9284 11.5304 15.6017V15.5107H6.73438Z"
        fill="currentColor"
      />
    </svg>
  )
})

FormTipIcon.displayName = 'FormTipIcon'
